import React, { useState } from 'react';
import Select from 'components/Atom/Select';
import DateRangePicker from 'components/Atom/DateRange';
import { Button } from 'components/Atom/Button';
import { BanksName } from 'utils/services';
import moment from 'moment';
import { Form, notification } from 'antd';
import { paymentType } from 'utils/constant';
const TransactionFilter = ({ filtersData, handleClose, onSearch, isExportFilter = false, filterToggler }) => {
  const [filterData, setFilterData] = useState(filtersData);
  const options = [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'CAPTURED',
      value: 'CAPTURED',
    },
    {
      label: 'REFUNDED',
      value: 'REFUNDED',
    },
    {
      label: 'PARTIALLY_REFUNDED',
      value: 'PARTIALLY_REFUNDED',
    },
    {
      label: 'CANCELLED',
      value: 'CANCELLED',
    },
    {
      label: 'TIMEOUT',
      value: 'TIMEOUT',
    },
    {
      label: 'DRAFT',
      value: 'DRAFT',
    },
    {
      label: 'FAILED',
      value: 'FAILED',
    },
    {
      label: 'OTP ACTION REQUIRED',
      value: 'OTP_ACTION_REQUIRED',
    },
    {
      label: 'PENDING',
      value: 'PENDING',
    },
    {
      label: 'VOID',
      value: 'VOID',
    },
    {
      label: 'AUTHORIZED',
      value: 'AUTHORIZED',
    },
  ];
  const binsOptions = [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'APPLIED',
      value: 'APPLIED',
    },
    {
      label: 'NOT APPLIED',
      value: 'NOT_APPLIED',
    },
  ];
  const sourceOptions = [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'SHOPIFY',
      value: 'shopify',
    },
    {
      label: 'CUSTOM PAYMENT',
      value: 'custom-payment',
    },
    {
      label: 'CUSTOM PAYMENT SHOPIFY',
      value: 'custom-payment-shopify',
    },
  ];
  const ruleOptions = [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'APPLIED',
      value: 'APPLIED',
    },
    {
      label: 'NOT APPLIED',
      value: 'NOT_APPLIED',
    },
  ];
  const handleOnChangeValue = (e, type) => {
    if (e === null || e === 'all') {
      setFilterData((prevState) => {
        const newState = { ...prevState };
        delete newState[type];
        return newState;
      });
    } else {
      setFilterData((pre) => ({ ...pre, [type]: e }));
    }
  };
  const onSubmit = () => {
    if (isExportFilter === true && filterData?.date_range == null) {
      notification.warning({ message: 'Please Select Date-Range', placement: 'bottomRight' });
      return;
    } else if (isExportFilter === true && filterData?.date_range?.length) {
      const start = moment(filterData.date_range[0]);
      const end = moment(filterData.date_range[1]);
      const diffInDays = end.diff(start, 'days');
      if (diffInDays > 92) {
        notification.error({ message: 'You can export data dump for a maximum of 3 months (up to 90 days)', placement: 'bottomRight' });
        return;
      }
    }
    if (Object.keys(filterData ?? {})?.length > 0 || (Object.keys(filterData ?? {})?.length === 0 && Object.keys(filtersData ?? {})?.length > 0)) {
      onSearch(filterData);
      handleClose();
    } else {
      notification.warning({ message: 'At least one filter is required', placement: 'bottomRight' });
    }
  };
  return (
    <div style={{ width: '100%' }}>
      <Form layout='vertical'>
        <div className='formContainer transaction-filter transaction-modal'>
          <div className=' mb-[0px]'>
            <Form.Item className='modalField customSelect font-bold mb-[0px]' label='Transaction Status:'>
              <Select
                handleChange={(e) => handleOnChangeValue(e.value, 'transaction_status')}
                defaultValue={filterData?.transaction_status ?? options[0]}
                optionsValue={options}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </div>
          <div className='mb-[0px]'>
            <Form.Item className='modalField customSelect font-bold mb-[0px]' label='BIN Discount:'>
              <Select
                handleChange={(e) => handleOnChangeValue(e.value, 'bins_discount')}
                defaultValue={filterData?.bins_discount ?? binsOptions[0]}
                optionsValue={binsOptions}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </div>
          <div className=' mb-[0px]'>
            <Form.Item className='modalField customSelect font-bold mb-[0px]' label='Source:'>
              <Select
                handleChange={(e) => handleOnChangeValue(e.value, 'transaction_source')}
                defaultValue={filterData?.transaction_source ?? sourceOptions[0]}
                optionsValue={sourceOptions}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </div>
          <div className=''>
            <Form.Item
              className='modalField font-bold mb-[0px]'
              label='Date Range:'
              rules={
                isExportFilter
                  ? [
                      {
                        required: true,
                        message: 'Date Range is required',
                      },
                    ]
                  : []
              }>
              <DateRangePicker
                onChange={(e) => handleOnChangeValue(e, 'date_range')}
                defaultValue={filterData?.date_range ? [moment(filterData?.date_range[0]), moment(filterData?.date_range[1])] : null}
                hideButton={true}
              />
            </Form.Item>
          </div>
          <div className='payment-type'>
            <Form.Item className='font-bold' label='Payment Method:'>
              <Select defaultValue={filterData?.paymentType ?? paymentType[0]} optionsValue={paymentType} handleChange={(e) => handleOnChangeValue(e.value, 'paymentType')} style={{ width: '100%' }} />
            </Form.Item>
          </div>
          <div className='payment-type'>
            <Form.Item className='font-bold' label='Gateway Type:'>
              <Select
                defaultValue={filterData?.gatewayType ?? 'all'}
                optionsValue={[{ label: 'All', value: 'all' }, ...BanksName]}
                handleChange={(e) => handleOnChangeValue(e.value, 'gatewayType')}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </div>
          <div className=' mb-[0px]'>
            <Form.Item className='modalField customSelect font-bold mb-[0px]' label='Fraud Rules:'>
              <Select handleChange={(e) => handleOnChangeValue(e.value, 'fraud_rule')} defaultValue={filterData?.fraud_rule ?? ruleOptions[0]} optionsValue={ruleOptions} style={{ width: '100%' }} />
            </Form.Item>
          </div>
        </div>
        <div className='binClass'>
          <div>
            <Button className='parentThree customExport' onClick={onSubmit}>
              <div onClick={filterToggler}>{isExportFilter ? 'Export' : 'Apply'}</div>
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default TransactionFilter;
